import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SubscriptionManagerTabView() {

    const PAYMENT_AMOUNT = 50;
    const isPremium = false;
    const isActive = false;
    const hasPremiumLocation = false;

    const { t, i18n } = useTranslation();

    return (
        <div className="">
            {/* Header */}
            <div className="text-center mb-8">
                <h1 className="text-2xl font-extrabold text-gray-900">
                    {t('premiumAccess')}
                </h1>
                <p className="mt-2 text-gray-600">
                    {hasPremiumLocation
                        ? t('premiumLocationPartner')
                        : t('oneTimePaymentInfo')}
                </p>
            </div>

            {/* Payment Card - Only show if NO premium OR if premium expired */}
            {(!isPremium || !isActive) && !hasPremiumLocation && (
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-6 text-white">
                        <h2 className="text-2xl font-bold mb-2">{t('premiumPackage')}</h2>
                        <p className="text-blue-100">
                            {t('packageSubtitle')}
                        </p>
                    </div>

                    <div className="p-8">
                        {/* Price */}
                        <div className="text-center mb-8 pb-8 border-b border-gray-200">
                            <div className="flex items-baseline justify-center mb-2">
                                <span className="text-5xl font-semibold text-gray-900">
                                    € {PAYMENT_AMOUNT}
                                </span>
                            </div>
                            <p className="text-gray-600 font-medium">
                                {t('oneTimePayment')}
                            </p>
                            <p className="text-sm text-gray-500 mt-1">
                                {t('accessUntil7Days')}
                            </p>
                        </div>

                        {/* Features */}
                        <div className="mb-8">
                            <h3 className="font-bold text-gray-900 mb-4 text-lg">
                                {t('whatYouGet')}
                            </h3>
                            <ul className="space-y-3">
                                {[
                                    t('unlimitedGuests'),
                                    t('unlimitedTables'),
                                    t('rsvpTracking'),
                                    t('emailSupport'),
                                    t('weekAfterWedding'),
                                ].map((feature, index) => (
                                    <li key={index} className="flex items-start">
                                        <svg
                                            className="w-6 h-6 text-green-500 mr-3 flex-shrink-0"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                        <span className="text-gray-700 text-lg">{feature}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* CTA Button */}
                        <Link
                            to="/register"
                            className="w-full flex items-center justify-center bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-4 px-6 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {i18n.language === 'hr' && 'Počnite besplatno'}
                            {i18n.language === 'en' && 'Start for free'}
                            {i18n.language === 'de' && 'Starten Sie kostenlos'}
                        </Link>

                        <p className="text-center text-sm text-gray-500 mt-4">
                            {t('securePaddlePaymentInfo')}
                        </p>
                    </div>
                </div>
            )}

            {/* Info Section */}
            <div className="mt-12 bg-gray-50 rounded-2xl p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-6">
                    {t('faq')}
                </h3>
                <div className="space-y-4">
                    <div>
                        <h4 className="font-semibold text-gray-900 mb-2">
                            {t('howLongAccess')}
                        </h4>
                        <p className="text-gray-600">
                            {t('premiumDurationInfo')}
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-gray-900 mb-2">
                            {t('whatHappensAfterExpiry')}
                        </h4>
                        <p className="text-gray-600">
                            {t('afterExpiryInfo')}
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold text-gray-900 mb-2">
                            {/* {t('isPaymentSecure')} */}
                        </h4>
                        <p className="text-gray-600">
                            {/* {t('paymentSecurityInfo')} */}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
